import type { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import { color, diagramStyle } from './palette';

/** PRD → builder → preview → staging → prod: the path a change takes, with a human review at every gate and CodeRabbit on the PR. */
export const SdlcPath: FC = () => {
  const theme = useTheme();
  const sub = { fill: color.muted, fontSize: 13 } as const;
  const lbl = { fontSize: 15, fontWeight: 600 } as const;
  const stages: Array<[string, string]> = [
    ['PRD', 'states intent'],
    ['builder', 'agents build'],
    ['preview', 'any PR, opt-in'],
    ['staging', 'gates pass'],
    ['prod', 'customers'],
  ];

  return (
    <svg viewBox="0 0 940 240" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="PRD → builder → preview → staging → prod" style={diagramStyle(theme)}>
      <defs>
        <marker id="academy-arrow-sdlc" markerWidth="8" markerHeight="8" refX="7" refY="4" orient="auto">
          <path d="M0,0 L8,4 L0,8 z" fill={color.muted} />
        </marker>
      </defs>
      {stages.map(([name, note], i) => {
        const x = 20 + i * 195;
        const last = i === stages.length - 1;
        return (
          <g key={name}>
            <rect x={x} y="90" width="120" height="56" rx="10" fill={last ? color.ok : 'none'} fillOpacity={last ? 0.15 : 1} stroke={last ? color.ok : color.muted} strokeWidth="2.5" />
            <text x={x + 60} y="124" textAnchor="middle" style={lbl} fill={color.fg}>
              {name}
            </text>
            <text x={x + 60} y="170" textAnchor="middle" style={sub}>
              {note}
            </text>
            {!last && (
              <g>
                <line x1={x + 122} y1="118" x2={x + 193} y2="118" stroke={color.muted} strokeWidth="2" markerEnd="url(#academy-arrow-sdlc)" />
                {/* The gate: a person looks before the change moves on */}
                <polygon points={`${x + 157},106 ${x + 169},118 ${x + 157},130 ${x + 145},118`} fill={color.paper} stroke={color.accent} strokeWidth="2" />
                <text x={x + 157} y="72" textAnchor="middle" style={sub}>
                  human review
                </text>
              </g>
            )}
          </g>
        );
      })}
      <line x1="372" y1="132" x2="372" y2="188" stroke={color.muted} strokeWidth="1.5" strokeDasharray="3 4" />
      <rect x="262" y="190" width="220" height="32" rx="16" fill="none" stroke={color.accent} strokeWidth="2" />
      <text x="372" y="211" textAnchor="middle" fontSize="14" fill={color.fg}>
        CodeRabbit reviews every PR
      </text>
    </svg>
  );
};
